/* eslint-disable react-hooks/exhaustive-deps */
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Container,
  TextField,
  IconButton,
  Typography,
  Collapse,
  Divider,
  Button,
  Grid
} from "@material-ui/core";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import SingleSelect from "../../components/SelectField/SingleSelect";
import PageTitle from "../../components/pageTitle/PageTitle";
import TableToolbar from "../../components/Table/TableToolbar";
import CircularProgress from "@mui/material/CircularProgress";
import useClientSummary from "../home/components/useClientSummary";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import styles from "../home/dashboard.module.scss";
import { Timestamp } from "firebase/firestore";
import { timeSheetDeleteTime, timeSheetUpdate, timeSheetUpdateTime } from "../../services/apiservices/timesheets";
import AuthContext from "../../hooks/authContext";
import { getSettings } from "../../services/apiservices/settings";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle } from "../../components/ui/dialog";
import { ClockInOut } from "../home/components/ClockInOutComponent";

const ShiftStatus = (props) => {
  const [selectedShift, setSelectedShift] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const getShiftData = (shiftData, shift) => {
    const result = [];
    for (let shiftObj in shiftData) {
      for (let element in shiftData[shiftObj]) {
        const title = shiftData[shiftObj][element]["title"];
        if (title !== "Opentasks") {
          result.push({
            value: title,
            label: title,
            data: shiftData[shiftObj],
            shiftId: shiftObj,
          });
        }
      }
    }
    if (result?.length === 0 || shift === "No Shift") {
    result?.push({
      value: "No Shift",
      label: "No Shift",
    });
  }
    return result;
  };

 const shiftDetails = getShiftData(
  props.appointment?.clientDetails?.shiftData,
  props?.appointment?.shift
    )?.filter(
      (obj, index, self) =>
        index === self?.findIndex((el) => el?.value === obj?.value)
    );



  const onSelectShift = async (event) => {
    const {
      target: { value },
    } = event;

    const selShiftData = shiftDetails?.find((ele) => ele.value === value);

    const apptData = {
      ...props.appointment,
      shiftId: selShiftData.shiftId,
      tasks: selShiftData.data,
    };
    delete apptData.clientDetails;
    delete apptData.id;

    setIsLoading(true);
    timeSheetUpdate(
      props.appointment.id,
      apptData,
      (_result) => {
        props?.setShow(false);
        setIsLoading(false);
        props.refreshData();
      },
      (_errr) => {
        props?.setShow(false);
        setIsLoading(false);
        props.refreshData();
      }
    );

    setSelectedShift(value);
  };

  useEffect(() => {
    setSelectedShift(() => {
      if (
        props.appointment?.tasks &&
        Object.keys(props.appointment?.tasks).length > 0
      ) {
        for (let ele in props.appointment?.tasks) {
          return props.appointment?.tasks[ele]["title"];
        }
      } else {
        return (
          <div>{"----"} <span style={{ color: "red" }}>{`(0 Tasks)`}</span></div>
        );
      }
    });
  }, [props.appointment]);

  // if (props.isEdit) {
    return (
      <>
        {isLoading ? (
          <>
            <CircularProgress size={20} />
          </>
        ) : (
          <div className="clientsingleSelect mt-8">
            <SingleSelect
              label="Select Shift"
              value={
                shiftDetails?.length === 1 &&
                shiftDetails[0]?.value === "No Shift"
                  ? "No Shift"
                  : selectedShift
              }
              className="field"
              name="selectedShift"
              onChange={(e) => {
                if (props?.appointment?.checkInDateTime) {
                  setShowDialog(true);
                  return;
                }
                if (
                  !(
                    shiftDetails?.length === 1 &&
                    shiftDetails[0]?.value === "No Shift"
                  )
                ) {
                  onSelectShift(e);
                }
              }}
              options={shiftDetails}
              disabled={
                shiftDetails?.length === 1 &&
                shiftDetails[0]?.value === "No Shift"
              }
              trimShift={true}
            />
          </div>
        )}

        {showDialog && (
          <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
            <DialogContent closeButton={false}>
              <DialogTitle className="mt-5 dark:text-white border-b pb-10">Shift Change Not Allowed</DialogTitle>
                <p className="font-medium text-[16px] dark:text-white mb-10 mt-5">This shift cannot be changed because work has started.</p>
                <div className="d-flex flex-justify-center">
                <Button style={{backgroundColor:"#16A34A", color:"white", maxWidth:"250px"}} variant="default" onClick={() => setShowDialog(false)} autoFocus>
                Close
                </Button>
                </div>
            </DialogContent>
          </Dialog>
        )}
      </>
    );
  // } else {
  //   return (
  //     <>
  //       {selectedShift}
  //     </>
  //   );
  // }
};


const ClientCard = ({ clientsList, show, toggleShow, saveData, handelDeleteTime, getTimeZoneData, getStatusTag, getTaskListByComma, getTaskCount,
  getClientsSummaryData, setShow, checkInDateTime, checkOutDateTime, setCheckInDateTime, setCheckOutDateTime, durationString, setDurationString, breakDurationString,
  setBreakDurationString}) => {

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  const handleOpenDialog = (client) => {
    setSelectedClient(client);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedClient(null);
  };

  const [openNewDialog, setOpenNewDialog] = useState(false);
  const [selectedNewClient, setSelectedNewClient] = useState(null);

  const handleOpenNewDialog = (client) => {
    setSelectedNewClient(client);
    setOpenNewDialog(true);
  };

  const handleCloseNewDialog = () => {
    setOpenNewDialog(false);
    setSelectedNewClient(null);
  };

  return clientsList?.map((appointment) => {
    const timezones = appointment?.calendarTimezone || 'America/New_York';
    const timezone = getTimeZoneData(timezones);

    const formattedStartDate = moment(appointment["appointmentDateTime"])
      .parseZone(timezones)
      .format("MMM DD YYYY");
    const formattedStartTime = moment(appointment["appointmentDateTime"])
      .parseZone(timezones)
      .format("h:mm a");

    const formattedEndDate = moment(appointment["appointmentDateTime"])
      .add(appointment["duration"], "minutes")
      .parseZone(timezones)
      .format("MMM DD YYYY");
    const formattedEndTime = moment(appointment["appointmentDateTime"])
      .add(appointment["duration"], "minutes")
      .parseZone(timezones)
      .format("h:mm a");

    return (
      <>
        <Box
          key={appointment.id}
          sx={{
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: 1,
            mb: 2,
            p: 2,
          }}
          className="bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] text-[#020817] dark:text-white"
        >
          <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2} >
            <Link to={`/peoples/createClient/${appointment?.clientId}`} className="text-blue-600 dark:text-blue-400 font-semibold text-lg">
              {appointment["name"]}
            </Link>
            {getStatusTag(appointment)}
          </Box>

          <Grid container spacing={2} className="mb-8">
            <Grid item xs={6} className="d-flex flex-direction-column">
              <Typography variant="body" className={styles.customHeader}>Start</Typography>
              <Typography variant="body" className="text-base font-medium text-[#020817] dark:text-white mt-1">{formattedStartTime} {timezone?.abbr}</Typography>
              <Typography variant="body" className={styles.customHeader}>{formattedStartDate}</Typography>
            </Grid>
            <Grid item xs={6} className="d-flex flex-direction-column">
              <Typography variant="body" className={styles.customHeader}>End</Typography>
              <Typography variant="body" className="text-base font-medium text-[#020817] dark:text-white mt-1">{formattedEndTime} {timezone?.abbr}</Typography>
              <Typography variant="body" className={styles.customHeader}>{formattedEndDate}</Typography>
            </Grid>
          </Grid>

          <Box mb={2}>
            <Typography variant="body" className={styles.customHeader}>Shift</Typography>
            <ShiftStatus
              appointment={appointment}
              refreshData={getClientsSummaryData}
              isEdit={show[appointment.id]}
              setShow={setShow}
            />
          </Box>

          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="body" className={styles.customHeader2}>
              Employee:{" "}
              <Link to={`/peoples/createEmp/${appointment?.userId}`} className="text-blue-600 dark:text-blue-400">
                {appointment.calendar}
              </Link>
            </Typography>
            <IconButton size="small" onClick={() => toggleShow(appointment.id)}>
              {show[appointment.id] ? <ExpandLess className="text-black dark:text-white" /> : <ExpandMore className="text-black dark:text-white" />}
            </IconButton>
          </Box>

          <Collapse in={show[appointment.id]} timeout="auto" unmountOnExit>
            <Box mt={2} pt={2} className="border-t border-gray-200 dark:border-gray-700">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body" className={styles.texts}>
                    Clock Times
                  </Typography>
                  {show[appointment?.id] ? (
                    <ClockInOut
                      cellData={appointment}
                      show={show[appointment?.id]}
                      checkInDateTime={checkInDateTime}
                      setCheckInDateTime={setCheckInDateTime}
                      checkOutDateTime={checkOutDateTime}
                      setCheckOutDateTime={setCheckOutDateTime}
                      setDurationString={setDurationString}
                      durationString={durationString}
                      breakDurationString={breakDurationString}
                      setBreakDurationString={setBreakDurationString}
                    />
                  ) : (
                    <>
                      <div>In: ----</div>
                      <div>Out: ----</div>
                    </>
                  )}
                </Grid>

                <Typography variant="body" style={{ padding: "6px 8px 2px 8px" }} className="pl-2 pt-3 font-medium text-sm text-[#020817] dark:text-white">
                  Tasks
                </Typography>
                <Grid xs={12} className="d-flex mt-1 pl-8">
                  <Grid item xs={6} className="d-flex flex-direction-column">
                    <Typography variant="body" className={styles.customHeader}>Assigned :</Typography>
                    <Typography onClick={() => handleOpenDialog(appointment)} className="mt-2 ml-2 text-base font-bold text-[#020817] dark:text-white cursor-pointer">
                      {getTaskCount(appointment, true)}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="d-flex flex-direction-column">
                    <Typography variant="body" className={styles.customHeader}>Completed :</Typography>
                    <Typography onClick={() => handleOpenNewDialog(appointment)} className="mt-2 ml-2 text-base font-bold text-[#020817] dark:text-white cursor-pointer">
                      {getTaskCount(appointment, false)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Box display="flex" justifyContent="flex-end" mt={3} gap={1}>
                <Button size="small" variant="outlined" className="dark:text-white" onClick={() => handelDeleteTime(appointment)}>Cancel</Button>
                <Button size="small" variant="contained" className="saveButton text-white dark:bg-[#078037] dark:text-white" onClick={() => saveData(appointment)}>Save</Button>
              </Box>
            </Box>
          </Collapse>
        </Box>
        {openDialog && (
          <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
          <DialogContent className="mt-12 bg-white dark:bg-[#2c3440] dark:text-white" >
          <Typography variant="body" className="mt-20 text-xl font-bold text-[#020817] dark:text-white">Tasks Assigned</Typography>
          <Divider /> 
            {selectedClient && (
              <>
                <Typography variant="body" className="text-base font-semibold mb-8 dark:text-white">Regular Task</Typography>
                <div className="mt-8">
                  <Typography className="text-sm text-gray-600 dark:text-white" variant="body">
                    {getTaskListByComma(selectedClient)}
                  </Typography>
                </div>

                <div className="mt-12">
                  <Typography variant="body" className="mt-4 text-base font-semibold mb-8 dark:text-white">Open Task</Typography>
                </div>
                <div className="mt-8">
                  <Typography variant="body" className="text-sm text-gray-600 dark:text-white">
                    {getTaskListByComma(selectedClient, 1)}
                  </Typography>
                </div>
              </>
            )}
          <div className="flex-justify-center mb-20">
            <Button variant="contained" onClick={handleCloseDialog} className="bg-green-700 text-white rounded-lg px-6 py-2">Close</Button>
          </div>
          </DialogContent>
        </Dialog>
        )}
      {openNewDialog && (
        <Dialog open={openNewDialog} onClose={handleCloseNewDialog} fullWidth maxWidth="sm">
          <DialogContent className="mt-12 bg-white dark:bg-[#2c3440] text-[#020817] dark:text-white">
          <Typography variant="body" className="mt-5 text-xl font-bold text-[#020817] dark:text-white">Tasks Assigned</Typography>
          <Divider />
            {selectedNewClient && (
              <>
                <Typography variant="body" className="text-base font-semibold mb-8 dark:text-white">Completed Task</Typography>
                <div className="mt-8">
                  <Typography variant="body" className="text-sm text-gray-600 dark:text-white">
                    {getTaskListByComma(selectedClient, 2)}
                  </Typography>
                </div>
              </>
            )}
          <div className="flex-justify-center mb-20">
            <Button variant="contained" onClick={handleCloseNewDialog} className="bg-green-700 text-white rounded-lg px-6 py-2">Close</Button>
          </div>
          </DialogContent>
        </Dialog>
        )}

      </>
    );
  });
};


function ClientSummary(_props) {
  const {
    // eslint-disable-next-line no-unused-vars
    sort,
    filterDate,
    clientsList,
    isLoading,
    handleDateChange,
    renderRow,
    setShow,
    show,
    getClientsSummaryData,
    getTimeZoneData,
    getStatusTag,
    getTaskListByComma,
    getTaskCount,
    toggleShow,
    changeDate,
    itemsPerPage,
    setItemsPerPage,
    employee,
    clients,
    appointments,
    deleteDialog,
    setDeleteDialog,
    handelConfirmDeleteTime,
    setUpdateDialog,
    updateDialog,
    handleConfirmUpdateTime,
    // checkInDateTime,
    // setCheckInDateTime,
    // checkOutDateTime,
    // setCheckOutDateTime,
    breakDurationString,
    setBreakDurationString
  } = useClientSummary(true);


  const [refreshing, setRefreshing] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const auth = useContext(AuthContext);
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const [settingsData, setSettingsData] = useState(null);
  const [checkInDateTime, setCheckInDateTime] = useState(null);
  const [checkOutDateTime, setCheckOutDateTime] = useState(null);
  const [durationString, setDurationString] = useState("—");

  const handleRefresh = async () => {
    setRefreshing(true);
    setShow(false);
    setExpanded(false);
    await getClientsSummaryData(true);
    setRefreshing(false);
  };

  const combineTime = (time, timezone) => {
    let timezoneOffset = moment().tz(timezone).format('Z');
    const onlyTime = moment(time, 'YYYY-MM-DD hh:mm A').format("HH:mm:ss");
    const onlyDate = moment(time, 'YYYY-MM-DD hh:mm A').format("YYYY-MM-DD");
    const mytime = `${onlyDate}T${onlyTime}${timezoneOffset}`;
    return new Date(mytime);
  };


  const handleUpdateCheckIn = async (time, cellData) => {
    const combinedTime = combineTime(
      `${moment(cellData?.datestart).format("YYYY-MM-DD")} ${time}`,
      cellData?.calendarTimezone
    );
    setCheckInDateTime(combinedTime);
  
    const formData = {
      checkInDateTime: Timestamp.fromDate(combinedTime),
      isWorking: true,
    };
  
    await timeSheetUpdateTime(cellData?.id, formData);
  };


  const handleUpdateCheckOut = async (time, cellData) => {
    const combinedTime = combineTime(
      `${moment(cellData?.datestart).format("YYYY-MM-DD")} ${time}`,
      cellData?.calendarTimezone
    );
    setCheckOutDateTime(combinedTime);
    const formData = {
      checkOutDateTime: Timestamp.fromDate(combinedTime),
      completed: true, 
      isWorking: false,
    };
    await timeSheetUpdateTime(cellData?.id, formData);
  };

  const handelDeleteTime = async (cellData) => {
    setShow(false);
    if (checkInDateTime || checkInDateTime) {
      await timeSheetDeleteTime(cellData?.apoointmentDetails?.id, cellData?.appointmentDate, ["checkInDateTime", "checkOutDateTime"]);
      await getClientsSummaryData();
    }
  }

  const saveData = async (cellData) => {
    setShow(false);
    if (checkInDateTime || checkInDateTime) {
      if (checkInDateTime) {
        await handleUpdateCheckIn(checkInDateTime, cellData);
      }
      if (checkOutDateTime) {
        await handleUpdateCheckOut(checkOutDateTime, cellData);
      }
      await getClientsSummaryData();
    }
  };

  useEffect(() => {
    getSettings('appointment_settings', companyId, (res) => {
      const data = res?.data?.find(item => !item.deleted);
      if (data?.schedulingSystem === "acuity") {
        setSettingsData(data);
      } else {
        setSettingsData(null);
      }
    })
  }, []);

  const tableRightComponent = () => {
    return (
        <div className="d-flex groupsearch mv-8 w-100">
        {settingsData !== null && (
          <div>
            <IconButton onClick={handleRefresh} disabled={refreshing}>
              <FontAwesomeIcon icon={faSyncAlt} className={styles.Action} />
            </IconButton>
          </div>
        )}
          <div className={isMobile || isLandscape ? "d-flex flex-center ml-40" : "d-flex flex-center"}>
            <IconButton onClick={() => changeDate(-1)} className="p-4">
              <ChevronLeft fontSize={"large"} className="text-black dark:text-white" />
            </IconButton>
            <TextField
              name="date"
              value={filterDate}
              fullWidth={true}
              size="small"
              variant="outlined"
              className={`field`}
              type={"date"}
              InputProps={{
                  classes: {
                    root: "bg-white dark:bg-[#1A1F2C] text-black dark:text-white",
                    input: "p-10",
                  },
              }}
              inputProps={{
                className: "p-10",
                min: moment().add(-30, "days").format("YYYY-MM-DD"),
                max: moment().add(15, "days").format("YYYY-MM-DD"),
              }}
              onChange={handleDateChange}
            />
            <IconButton onClick={() => changeDate(1)} className="p-4">
              <ChevronRight fontSize={"large"} className="text-black dark:text-white" />
            </IconButton>
          </div>
        </div>
    );
  };
  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Daily Summary Report"
          showBreadcrumb={[{ label: "Home", to: "/" }]}
          BreadCrumbCurrentPageTitle={"Daily Summary Report"}
          showLastSeen={true}
        />

        <div className={`dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] sectionBox clientWrap ${styles.summaryTableWrap}`}>
          <TableToolbar
            title="Daily Summary Report"
            rightComponent={tableRightComponent()}
            // handleRefresh={handleRefresh}
            // refreshing={refreshing}
            refresh={true}
          />

          {!isMobile && !isLandscape && (
            <Box>
              {isLoading ? (
                <div className="dark:text-white text-[#020817]" style={{  textAlign: "center", padding: "12px", fontSize: "14px", fontWeight: "600" }}>Loading...</div>
              ) : (
                <>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow className="bg-[#f8fafc] dark:bg-[#1A1F2C]">
                          <TableCell className="text-[#020817] dark:text-[#94A3B8] font-medium">Client</TableCell>
                          <TableCell className="text-[#020817] dark:text-[#94A3B8] font-medium">Status</TableCell>
                          <TableCell className="text-[#020817] dark:text-[#94A3B8] font-medium">Shift</TableCell>
                          <TableCell className="text-[#020817] dark:text-[#94A3B8] font-medium">Start</TableCell>
                          <TableCell className="text-[#020817] dark:text-[#94A3B8] font-medium">End</TableCell>
                          <TableCell align="right" className="text-[#020817] dark:text-[#94A3B8] font-medium">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>{renderRow()}</TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </Box>
          )}

            {(isMobile || isLandscape) && (
                      <div>
                        {refreshing === true ? (
                          <div className="pv-10 ph-15 text-center fw-bold">
                            Loading...
                          </div>
                        ) : clientsList.length === 0 ? (
                          <div className="pv-10 ph-15 text-center fw-bold">
                            No Records Found
                          </div>
                        ) : (
                          <>
                            <ClientCard
                              clientsList={clientsList}
                              show={show}
                              toggleShow={toggleShow}
                              saveData={saveData}
                              handelDeleteTime={handelDeleteTime}
                              getTimeZoneData={getTimeZoneData}
                              getStatusTag={getStatusTag}
                              getTaskListByComma={getTaskListByComma}
                              getTaskCount={getTaskCount}
                              getClientsSummaryData={getClientsSummaryData}
                              setShow={setShow}
                              checkInDateTime={checkInDateTime}
                              checkOutDateTime={checkOutDateTime}
                              setCheckInDateTime={setCheckInDateTime}
                              setCheckOutDateTime={setCheckOutDateTime}
                              setDurationString={setDurationString}
                              durationString={durationString}
                              breakDurationString={breakDurationString}
                              setBreakDurationString={setBreakDurationString}
                            />
                          </>
                        )}
                      </div>
                    )}
        </div>
      </Container>
    </>
  );
}

export default ClientSummary;
